import {DrawerProps} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {BillingProvider} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: BillingProvider,
        // Resolves true when the save landed. The drawer closes only then: a rejected
        // save keeps it open with the operator's values (§7).
        handleSubmit: (values: BillingProvider) => Promise<boolean>
    }) => {

    const title = record?.id ? I18n.get('Edit Billing Provider') : I18n.get('Add Billing Provider');

    const handleFormSubmit = async (values: BillingProvider) => {
        const saved = await handleSubmit(values);
        if (saved) {
            onClose();
        }
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
